export default __webpack_public_path__ + "static/media/background.f3a82d7f.jpg";